// src/components/ExcelProcessor.js
import React, { useState } from "react";
import * as XLSX from "xlsx";
import LmvExcelReport from "./Lmvcjmexcelreport";
import "./ExcelProcessor.css"; // Create a CSS file for styles

const ExcelProcessor = () => {
  const [formattedData, setFormattedData] = useState([]);
  const [isProcessed, setIsProcessed] = useState(false);
  const [error, setError] = useState(null); // Track errors

  const processExcel = (file) => {
    setError(null); // Reset error state

    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: true });

        // Filter rows where Status is "Accepted"
        const filteredData = jsonData.filter((row) => row["Status"] === "Accepted");

        const processedData = filteredData.map((row) => ({
          date: row["Created At"] || "",
          questions: [
            {
              answer: [row["Auditor Email"] || ""],
              question: "Enter your Email",
              selection: "single",
              type: "text",
              _id: "66fb93d47bf16b4e147cf30b",
            },
            {
              answer: [row["Mention the dealership store name you visited"] || ""],
              question: "Enter Bank",
              selection: "single",
              type: "text",
              _id: "66fb93d47bf16b4e147cf30b",
            },
            {
              answer: [row["Location Name"] || ""],
              question: "Enter your City",
              selection: "single",
              type: "text",
              _id: "66fb93d47bf16b4e147cf30b",
            },
            {
              answer: [row["Select the type of vehicle you are making enquiry for"] || ""],
              question: "Type Of User",
              selection: "single",
              type: "text",
              _id: "66fb93d47bf16b4e147cf30b",
            },
          ],
        }));

        setFormattedData(processedData);
        setIsProcessed(true);
      } catch (err) {
        setError("Failed to process the file. Please ensure it is a valid Excel file.");
        console.error("Error processing Excel file:", err);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      processExcel(file);
    } else {
      setError("Please select a valid file.");
    }
  };

  return (
    <div className="excel-processor-container">
      <h2 className="header">Excel File Processor</h2>
      <div className="file-upload">
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileUpload}
          className="file-input"
        />
      </div>

      {error && <div className="error-message">{error}</div>}

      {isProcessed && (
        <div className="report-section">
          <h3>Processed Data</h3>
          <LmvExcelReport data={formattedData} />
        </div>
      )}
    </div>
  );
};

export default ExcelProcessor;
